// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames not based on template
	if (chunkId === 218) return "static/chunks/218.67fc34d671566b56.js";
	// return url for filenames based on template
	return "static/chunks/" + (chunkId === 5730 ? "44530001" : chunkId) + "-" + {"403":"025c92d623ad5fa2","5730":"1e375766b3760fa1","6140":"c52bf5de588aad0d"}[chunkId] + ".js";
};